export default __webpack_public_path__ + "static/media/988.636bd911.png";